import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WorkflowsPage } from "@/features/workflows/WorkflowsPage";

const search = z.object({
  filter: z.enum(["all", "published", "draft", "paused", "overrides"]).optional(),
  category: z.string().optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/automations/")({
  validateSearch: search,
  component: () => <WorkflowsPage search={Route.useSearch()} />,
});
